import { render, staticRenderFns } from "./ConversionImpactChip.vue?vue&type=template&id=b1aee132&"
import script from "./ConversionImpactChip.vue?vue&type=script&lang=js&"
export * from "./ConversionImpactChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports